module.exports = "./assets/resources/64455481b83a7f3e4165b73952ad223c.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/assets/img/user.png
// module id = 412
// module chunks = 0